
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import GeneralServiceCharge from "../components/GeneralServiceCharges"
import Footer from "../components/footer";

function ServiceChargesPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      <GeneralServiceCharge /> 
    </div>
    <Footer /> 
  </div>
  // <Login/>
  );
}
export default ServiceChargesPage;
